import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {Img, SocialBadgeSM} from 'apps/shared/components';
import {defaultAvatarImg} from 'assets/images';

export default class Avatar extends Component {
  static propTypes = {
    image: PropTypes.string,
    badgeImage: PropTypes.string,
    badgeText: PropTypes.string,
    badgeTextPosition: PropTypes.oneOf(['left', 'right']),
    style: PropTypes.oneOf(['circle', 'square']),
    size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
    className: PropTypes.string,
    avatarClasses: PropTypes.string,
    socialNetwork: PropTypes.oneOf(['facebook', 'twitter', 'instagram', 'youtube'])
  }

  static defaultProps = {
    image: defaultAvatarImg,
    style: 'circle',
    badgeImage: null,
    badgeText: '',
    badgeTextPosition: 'right',
    size: 'sm',
    className: '',
    avatarClasses: '',
    socialNetwork: null
  }

  state = {
    hasError: false
  }

  componentWillReceiveProps(props) {
    if (props.image !== this.props.image) {
      this.setState({hasError: false});
    }
  }

  onAvatarError = () => {
    this.setState({hasError: true});
  }

  render = () => {
    const {hasError} = this.state;
    const {
      image,
      badgeTextPosition,
      style,
      className,
      avatarClasses,
      socialNetwork,
      size,
      width,
      height,
      badgeText,
      badgeImage,
      ...other
    } = this.props;

    let bImage = badgeImage;
    let bText = badgeText;

    const sizes = {
      sm: 'small',
      md: 'medium',
      lg: 'large',
      xl: 'xl'
    };

    const imgSizes = {
      sm: 40,
      md: 80,
      lg: 91,
      xl: 121
    };

    const classes = classnames('vf-avatar', style, className, sizes[size], {
      'text-badge-left': badgeTextPosition === 'left',
      'text-badge-right': badgeTextPosition === 'right'
    });

    const containerStyle = {width, height};
    const imageStyle = {
      width,
      height
    };

    if (bImage || socialNetwork) {
      bImage = (
        <div className='vf-avatar-badge'>
          {socialNetwork
            ? <SocialBadgeSM socialNetwork={socialNetwork} />
            : <img className='vf-avatar-badge-image' src={badgeImage} alt='' />
          }
        </div>);
    }

    if (bText) {
      bText = (
        <div className='vf-avatar-text-badge'>
          <span>{badgeText}</span>
        </div>
      );
    }

    return (
      <div className={classes} style={containerStyle} {...other}>
        <Img
          className={`vf-avatar-image ${avatarClasses}`}
          alt='avatar'
          width={width || imgSizes[size]}
          height={height || imgSizes[size]}
          src={hasError ? defaultAvatarImg : image}
          imgixParams={{crop: 'faces'}}
          htmlAttributes={{
            onError: this.onAvatarError,
            style: imageStyle
          }}
        />


        {badgeImage}
        {badgeText}
      </div>
    );
  }
}
